// extracted by mini-css-extract-plugin
module.exports = {"comp":"M_comp__M_QzJ"};